export default {
    noProgram: {
        title: "No program available",
        description: "This business has no active benefits program at the moment.",
    },
    notFound: {
        title: "Business unavailable",
        description: "Check that the link is correct.",
    },
    error: {
        title: "Could not load",
        description: "Check your connection and try again.",
        retry: "Try again",
    },
};
